/**
 * Designed by OnHOW YouTube Channel - Anas El Medlaoui
 * Adjusted for Shopify Horizon Theme
 */

const onhowStyles = `
  .product__accordion {
    margin-top: 24px;
  }

  .product__accordion details {
    border-top: 1px solid rgba(var(--color-foreground), 0.14);
  }

  .product__accordion details:last-child {
    border-bottom: 1px solid rgba(var(--color-foreground), 0.14);
  }

  .product__accordion summary {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    cursor: pointer;
    padding: 18px 0;
    list-style: none;
  }

  .product__accordion summary::-webkit-details-marker {
    display: none;
  }

  .product__accordion summary::marker {
    display: none;
    content: "";
  }

  .product__accordion .summary__title {
    flex: 1;
  }

  .product__accordion .accordion__title {
    margin: 0;
    font-size: calc(var(--font-heading-scale) * 1.13em);
    line-height: 1.3;
  }

  .product__accordion summary::after {
    content: "›";
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 28px;
    width: 28px;
    height: 28px;
    font-size: 30px;
    line-height: 1;
    font-weight: 300;
    color: currentColor;
    transition: transform 250ms ease;
    transform: rotate(0deg);
  }

  .product__accordion details[open] summary::after {
    transform: rotate(90deg);
  }

  .product__accordion summary:hover .accordion__title {
    opacity: 0.75;
  }

  .product__accordion .accordion__content {
    padding: 0 0 20px 0;
  }

  .product__accordion .accordion__content > *:first-child {
    margin-top: 0;
  }

  .product__accordion .accordion__content > *:last-child {
    margin-bottom: 0;
  }

  .product__accordion details[open] .accordion__content {
    animation: slowReveal 400ms ease-in-out;
  }

  @keyframes slowReveal {
    0% { 
      opacity: 0; 
      transform: translateY(-8px); 
    }

    100% { 
      opacity: 1; 
      transform: translateY(0); 
    }
  }
`;

function addStyles(stylesText) {
  if (document.getElementById('onhow-description-accordion-styles')) return;

  const styleElement = document.createElement('style');
  styleElement.id = 'onhow-description-accordion-styles';
  styleElement.textContent = stylesText;
  document.head.appendChild(styleElement);
}

class OnhowDescriptionAccordion {
  constructor() {
    this.descriptionContainer = this.findDescriptionContainer();

    if (!this.descriptionContainer) return;

    if (this.descriptionContainer.dataset.accordionInitialized === 'true') return;
    this.descriptionContainer.dataset.accordionInitialized = 'true';

    addStyles(onhowStyles);

    this.init();
  }

  findDescriptionContainer() {
    const possibleContainers = document.querySelectorAll(
      'rte-formatter.rte, .product__description.rte'
    );

    return Array.from(possibleContainers).find(container => {
      return container.querySelector('h3');
    });
  }

  init() {
    this.originalContent = this.descriptionContainer.innerHTML;

    const h3Elements = this.descriptionContainer.querySelectorAll('h3');

    if (h3Elements.length > 0) {
      this.createAccordion(h3Elements);
    }
  }

  createAccordion(h3Elements) {
    const newDescriptionContent = document.createElement('div');
    const accordionContainer = document.createElement('div');

    accordionContainer.className = 'accordion product__accordion quick-add-hidden';

    const firstH3 = h3Elements[0];
    let currentIntroElement = this.descriptionContainer.firstElementChild;

    while (currentIntroElement && currentIntroElement !== firstH3) {
      newDescriptionContent.appendChild(currentIntroElement.cloneNode(true));
      currentIntroElement = currentIntroElement.nextElementSibling;
    }

    h3Elements.forEach((h3Element, index) => {
      const contentElements = [];
      let currentElement = h3Element.nextElementSibling;

      while (currentElement && currentElement.tagName !== 'H3') {
        contentElements.push(currentElement.cloneNode(true));
        currentElement = currentElement.nextElementSibling;
      }

      const details = document.createElement('details');
      details.id = `Details-${index}`;

      if (index === 0) {
        details.setAttribute('open', '');
      }

      const summary = document.createElement('summary');
      summary.setAttribute('role', 'button');
      summary.setAttribute('aria-expanded', index === 0 ? 'true' : 'false');
      summary.setAttribute('aria-controls', `ProductAccordion-${index}`);

      const summaryTitle = document.createElement('div');
      summaryTitle.className = 'summary__title';

      const heading = document.createElement('h2');
      heading.className = 'h4 accordion__title';
      heading.textContent = h3Element.textContent.trim();

      const content = document.createElement('div');
      content.className = 'accordion__content rte';
      content.id = `ProductAccordion-${index}`;

      contentElements.forEach(element => {
        content.appendChild(element);
      });

      summaryTitle.appendChild(heading);
      summary.appendChild(summaryTitle);
      details.appendChild(summary);
      details.appendChild(content);
      accordionContainer.appendChild(details);
    });

    newDescriptionContent.appendChild(accordionContainer);

    this.descriptionContainer.innerHTML = '';
    this.descriptionContainer.appendChild(newDescriptionContent);

    this.initializeAccordion();
  }

  initializeAccordion() {
    const detailsElements = this.descriptionContainer.querySelectorAll('details');

    detailsElements.forEach(details => {
      const summary = details.querySelector('summary');

      summary.addEventListener('click', event => {
        event.currentTarget.setAttribute(
          'aria-expanded',
          !details.hasAttribute('open')
        );
      });

      details.addEventListener('keyup', event => {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;

        const summaryElement = openDetailsElement.querySelector('summary');
        openDetailsElement.removeAttribute('open');
        summaryElement.setAttribute('aria-expanded', 'false');
        summaryElement.focus();
      });
    });
  }

  restoreOriginalDescription() {
    if (this.originalContent) {
      this.descriptionContainer.innerHTML = this.originalContent;
      this.descriptionContainer.dataset.accordionInitialized = 'false';
    }
  }
}

(function() {
  function initAccordion() {
    const hasDescriptionWithH3 = document.querySelector(
      'rte-formatter.rte h3, .product__description.rte h3'
    );

    if (hasDescriptionWithH3) {
      new OnhowDescriptionAccordion();
    } else if (document.readyState !== 'complete') {
      setTimeout(initAccordion, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordion);
  } else {
    initAccordion();
  }
})();